<div class="hub-root">
  <div class="hub-toolbar">
    <button
      type="button"
      class="nx-c4g-support-ticket-add-btn"
      (click)="openNewTicketDialog()"
    >
      {{ 'supportTickets.addTicket' | translate }}
    </button>
  </div>

  <div class="list-panel">
    <div *ngIf="listLoading" class="loading-row">
      {{ 'supportTickets.loading' | translate }}
    </div>

    <div *ngIf="!listLoading && items.length === 0" class="empty-state">
      {{ 'supportTickets.emptyList' | translate }}
    </div>

    <div class="ticket-list" *ngIf="!listLoading && items.length > 0">
      <div *ngFor="let t of items" class="ticket-card">
        <button
          type="button"
          class="ticket-summary"
          (click)="openTicketDetail(t)"
        >
          <div class="summary-top">
            <span class="ticket-id-wrap">
              <span class="ticket-id">{{ t._id }}</span>
              <span
                *ngIf="unreadCount(t) > 0"
                class="unread-badge"
                [attr.aria-label]="
                  'supportTickets.unreadMessagesAria'
                    | translate: { count: unreadCount(t) }
                "
                >{{ unreadLabel(t) }}</span>
            </span>
            <span class="ticket-status" [attr.data-status]="t.status">{{
              statusLabel(t.status)
            }}</span>
          </div>
          <div class="subject">{{ t.subject }}</div>
          <div class="meta">{{ formatDate(t.createdAt) }}</div>
        </button>
      </div>
    </div>

    <div class="pager" *ngIf="!listLoading && total > 0">
      <button
        mat-stroked-button
        type="button"
        (click)="prevPage()"
        [disabled]="page <= 1"
      >
        {{ 'supportTickets.previous' | translate }}
      </button>
      <span>{{
        'supportTickets.pageOfTotal'
          | translate
            : {
                page: page,
                totalPages: totalPages,
                total: total,
              }
      }}</span>
      <button
        mat-stroked-button
        type="button"
        (click)="nextPage()"
        [disabled]="page >= totalPages"
      >
        {{ 'supportTickets.next' | translate }}
      </button>
    </div>
  </div>
</div>
